import { createSlice } from "@reduxjs/toolkit";

export const estadoSlices = createSlice({
  name: "estado",
  initialState: {
    value: [false],
  },
  reducers: {
    addList1: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList1 } = estadoSlices.actions;

export default estadoSlices.reducer;
